import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stepper, Typography, Button } from "@ann/web-components";
import { RolesAndGroupContainer, RoleAndGroupTitle, StepperContainer, SectionHeader } from "./RolesAndGroup.styled";
import { INVITE_STEPS, STEP_IDS } from "../../constants/inviteSteps";
import { AssignRoleCard, GroupsCard } from "../../components";
import { AssignRolesModal, AddGroupModal } from "../../../../components";

const RolesAndGroup = ({
  emails = [],
  selected = [],
  assignRolesSearchValue,
  setAssignRolesSearchValue,
  selectedRoles,
  setSelectedRoles,
  rolesData,
  setRolesData,
  assignGroupsSearchValue,
  setAssignGroupsSearchValue,
  selectedGroups,
  setSelectedGroups,
  groupsData,
  setGroupsData,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!emails.length || !selected.length) {
      navigate("/v2/user-management/invite-user", { replace: true });
    }
  }, [emails.length, selected.length, navigate]);
  const [isAssignRolesModalOpen, setIsAssignRolesModalOpen] = useState(false);
  const [isAddGroupModalOpen, setIsAddGroupModalOpen] = useState(false);
  const [pendingSelectedRoles, setPendingSelectedRoles] = useState(selectedRoles);
  const [pendingSelectedGroups, setPendingSelectedGroups] = useState(selectedGroups);

  const handleOpenAssignRolesModal = () => {
    setPendingSelectedRoles(selectedRoles);
    setIsAssignRolesModalOpen(true);
  };

  const handleCloseAssignRolesModal = () => setIsAssignRolesModalOpen(false);
  const handleCloseAddGroupModal = () => setIsAddGroupModalOpen(false);

  const handleClearSelectedRole = (roleId) => {
    setSelectedRoles((current) => current.filter((id) => id !== roleId));
  };

  const handleOpenAddGroupModal = () => {
    setPendingSelectedGroups(selectedGroups);
    setIsAddGroupModalOpen(true);
  };

  const handleClearSelectedGroup = (groupId) => {
    setSelectedGroups((current) => current.filter((id) => id !== groupId));
  };

  return (
    <RolesAndGroupContainer>
      <StepperContainer>
        <Stepper
          activeStep={STEP_IDS.ROLES_AND_GROUPS}
          onSelectStep={() => { }}
          steps={INVITE_STEPS}
        />
      </StepperContainer>
      <SectionHeader>
        <RoleAndGroupTitle>
          <Typography category="title" size="small" weight="bold">Assign a role</Typography> <div className="subtitle">(<span>optional</span>)</div>
        </RoleAndGroupTitle>
        <Button label="Assign a role" size="small" iconRight="plus" onClick={handleOpenAssignRolesModal} />
      </SectionHeader>
      <div className="subtitle">Assign permissions using predefined roles.</div>
      <AssignRoleCard
        onAssignRole={handleOpenAssignRolesModal}
        selectedRoles={selectedRoles}
        onRemoveRole={handleClearSelectedRole}
        rolesData={rolesData}
      />
      <SectionHeader>
        <RoleAndGroupTitle>
          <Typography category="title" size="small" weight="bold">Groups</Typography> <div className="subtitle">(<span>optional</span>)</div>
        </RoleAndGroupTitle>
        <Button type="secondary" label="Add groups" size="small" iconRight="plus" onClick={handleOpenAddGroupModal} />
      </SectionHeader>
      <div className="subtitle">Add users to groups to organize them by team, department, or location. Groups make it easier to manage users across your workspace.</div>
      <GroupsCard
        onAddGroups={handleOpenAddGroupModal}
        selectedGroups={selectedGroups}
        onRemoveGroup={handleClearSelectedGroup}
        groupsData={groupsData}
      />

      <AssignRolesModal
        isOpen={isAssignRolesModalOpen}
        onClose={handleCloseAssignRolesModal}
        searchValue={assignRolesSearchValue}
        setSearchValue={setAssignRolesSearchValue}
        selectedRoles={pendingSelectedRoles}
        setSelectedRoles={setPendingSelectedRoles}
        onConfirmSelection={(selectedRoleIds, rolesDataFromModal) => {
          setSelectedRoles(selectedRoleIds);
          if (rolesDataFromModal) {
            setRolesData(rolesDataFromModal);
          }
        }}
      />
      <AddGroupModal
        isOpen={isAddGroupModalOpen}
        onClose={handleCloseAddGroupModal}
        searchValue={assignGroupsSearchValue}
        setSearchValue={setAssignGroupsSearchValue}
        selectedGroups={pendingSelectedGroups}
        setSelectedGroups={setPendingSelectedGroups}
        onConfirmSelection={(selectedGroupIds, groupsDataFromModal) => {
          setSelectedGroups(selectedGroupIds);
          if (groupsDataFromModal) {
            setGroupsData(groupsDataFromModal);
          }
        }}
      />
    </RolesAndGroupContainer>
  );
};

export default RolesAndGroup;

